import React, { useState, useEffect } from "react";
import { useLocation, Route, Switch, Redirect } from "react-router-dom";
// reactstrap components
import { Container } from "reactstrap";
// core components
import AssociateNavBar from "components/Navbars/AssociateNavBar";
import AdminFooter from "components/Footers/AdminFooter.js";
import Sidebar from "components/Sidebar/Sidebar.js";

import associateRoutes from "associateRoutes.js";

const AssociateLayout = (props) => {
  console.log("PROPS inside Associate", props);
  const mainContent = React.useRef(null);
  const location = useLocation();

  const [logo, setLogo] = useState(
    require("../assets/img/brand//adect-logo.png").default
  );

  useEffect(() => {
    const idenfityLogo = () => {
      if (process.env.REACT_APP_TENANT.includes("ADECT")) {
        setLogo(require("../assets/img/brand//adect-logo.png").default);
      } else if (process.env.REACT_APP_TENANT.includes("GCO")) {
        setLogo(require("../assets/img/brand//gco-logo.png").default);
      } else if (process.env.REACT_APP_TENANT.includes("APPSTORE")) {
        setLogo(require("../assets/img/brand//asqs-logo.png").default);
      }
    };
    idenfityLogo();
  }, []);

  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    mainContent.current.scrollTop = 0;
  }, [location]);

  const getRoutes = (associateRoutes) => {
    return associateRoutes.map((prop, key) => {
      if (prop.layout === "/associates") {
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };

  const getBrandText = (path) => {
    for (let i = 0; i < associateRoutes.length; i++) {
      if (
        props.location.pathname.indexOf(
          associateRoutes[i].layout + associateRoutes[i].path
        ) !== -1
      ) {
        return associateRoutes[i].name;
      }
    }
    return "Brand";
  };

  return (
    <>
      <Sidebar
        {...props}
        associateRoutes={associateRoutes}
        logo={{
          innerLink: "/associates/home",
          imgSrc: logo,
          imgAlt: "...",
        }}
      />
      <div className="main-content" ref={mainContent}>
        <AssociateNavBar
          {...props}
          data={[1, 2, 3]}
          brandText={getBrandText(props.location.pathname)}
        />
        <Switch>
          {getRoutes(associateRoutes)}
          <Redirect from="*" to="/associates/home" />
        </Switch>
        <Container fluid>
          <AdminFooter />
        </Container>
      </div>
    </>
  );
};

export default AssociateLayout;
